import React, { useState } from "react";
import Box from "@mui/material/Box";
import Projectcolors from "../../Utils/Colors";
import { baseURL } from "../../Config/config";
import {

  TableBody,
  TableContainer,
  TableHead,
  Typography,
} from "@mui/material";
import TableRow, { tableRowClasses } from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

import Divider from "@mui/material/Divider";
import { Button } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TableViewIcon from "@mui/icons-material/TableView";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import Plot from "react-plotly.js";
import Table from "@mui/material/Table";
import Paper from "@mui/material/Paper";
import { Link } from "@mui/material";
import Radio from "@mui/material/Radio";
import DownloadIcon from "@mui/icons-material/Download";
import SsidChartOutlinedIcon from "@mui/icons-material/SsidChartOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import GlobalLoader from "../CommonC/GlobalLoader";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ShowChartIcon from '@mui/icons-material/ShowChart';


function Validate(props) {
   const headerStyle = {
  backgroundColor: "#0078c9",
  color: "white",
  fontSize: "12px",
  fontWeight: 600,
  whiteSpace: "nowrap",
};
  const [validationdata, setValidationdata] = React.useState([]);

  const [showtable, setshowtable] = React.useState(true);
  const [status, setStatus] = React.useState([]);
  const [linestatus, setlineStatus] = React.useState([]);
  const [index, setIndex] = React.useState();
  const [parity, setParity] = React.useState(true);
  const [labels, setlabels] = React.useState([]);
  const [r2, setr2] = React.useState([]);
  const [q2, setq2] = React.useState([]);
  const [allr2, setallr2] = React.useState([]);
  const [allq2, setallq2] = React.useState([]);
  const [allmodel, setAllmodel] = React.useState([]);
  const [cat, setcat] = React.useState([]);
  const [selectedsnapshot, setselectedsnapshot] = React.useState(null);
  const [logistic, setLogistic] = React.useState(false);
  const [ranking, setRanking] = React.useState(false);
  const [r2q2, setr2q2] = React.useState(false);
  const initialState = new Array(50).fill(false);
  const [checkedState, setCheckedState] = useState(initialState);
  const [annstatus, setannstatus] = useState(false);
  const [getLoader, setGetLoader] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(0);
  const [ranks, setRanks] = React.useState([]);
  const [independent, setIndependent] = React.useState([]);
  const [dependent, setdependent] = React.useState([]);
  const [timeseries, setTimeseries] = React.useState([]);
  const [opengraph, setOpengraph] = React.useState(false);
  const [lineopengraph, setlineOpengraph] = React.useState(false);
  const [date_train, setDateTrain] = React.useState([]);
  const [date_test, setDateTest] = React.useState([]);
  const [ytrain, setytrain] = React.useState([]);
  const [ypred, setypred] = React.useState([]);
  const [forecasting, setforecasting] = React.useState([]);
  const [title, setTitle] = React.useState("");
  const [lineobserved, setlineobserved] = React.useState([]);
  const [linepredicted, setlinepredicted] = React.useState([]);
  const [lineplottitle, setlineplottitle] = React.useState([]);

  const handleChange = (item, position) => {
    setSelectedValue(position);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlegraphOpen = (title, dates, predictions) => {
    setDateTrain(dates[0]);
    setDateTest(dates[1]);
    setytrain(predictions[0]);
    setypred(predictions[1]);
    setforecasting(predictions[2]);
    setTitle(title);
    setOpengraph(true);
  };



  const handlelineOpen = (observed, predicted, title) => {
    setlineobserved(observed);
    setlinepredicted(predicted);
    setlineOpengraph(true);
    setlineplottitle(title);
  };

  const handlelineClose = () => {
    setlineOpengraph(false);
  };

  const handlegraphClose = () => {
    setOpengraph(false);
  };

  
  let newArray = [];
  let lineArray = [];

  const initializestatus = (data) => {
    data.allmodel[0].map((item, i) => {
      newArray.push(true);
      lineArray.push(false);
    });
    setStatus(newArray);
    setlineStatus(lineArray);


  };

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    [`&.${tableRowClasses.root}`]: {
      height: "2px",
      minHeight: "2px",
    },
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
  
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
      padding: `4px 10px !important`,
      fontSize: "11px",
      // height:1
    },
    [`&.${tableCellClasses.head}`]: {
      padding: `4px 10px !important`,
      fontSize: "11px",
      // height:1
    },
  }));

  React.useEffect(() => {
    getvalidationdata();
    getSpearman();
  }, []);

  const getvalidationdata = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(`${baseURL}/getvalidationdata?projectID=${ProjectID}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.message === 0) {
          setMessage(true);
          setGetLoader(false);
        } else {
          setValidationdata(data.allmodel[0]);
          setAllmodel(data.allmodel);
          initializestatus(data);
          setlabels(data.labels);
          setallr2(data.r2);
          setallq2(data.q2);
          setr2(data.r2[0]);
          setq2(data.q2[0]);
          setcat(data.cat);
          setTimeseries(data.timeseries);
          console.log(data.allmodel[0])
          setGetLoader(false);
          if (data.cat.includes(false) === false) {
            setLogistic(true);
            setParity(false);
          }
        }
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("Err", err);
      });
  };
  const handleClick = (idx) => {
    setIndex(idx);
    let index = idx;
    const dataArray = Array.from(status);
    dataArray[idx] = !status[idx];
    setStatus(dataArray);

    const linedataArray = Array.from(linestatus);
    linedataArray[idx] = false;
    setlineStatus(linedataArray);
  };

  const handleLinePlot = (idx) => {
    //setIndex(idx);
    //let index = idx;
    const dataArray = Array.from(status);
    dataArray[idx] = false;
    setStatus(dataArray);

    const linedataArray = Array.from(linestatus);
    linedataArray[idx] = !linestatus[idx];
    setlineStatus(linedataArray);
  };
  console.log(validationdata)
  const deleteSnap = (idx) => {
    const ProjectID = sessionStorage.getItem("projectID");
    setGetLoader(true);
    try {
      fetch(`${baseURL}/deleteSnap`, {
        method: "POST",
        body: JSON.stringify({
          idx: idx,
          ProjectID,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((result) => {
          setAllmodel(result.allmodel);
          setGetLoader(false);
        })
        .catch((error) => {
          console.log("error", error);
          setGetLoader(false);
        });
    } catch (error) {
      console.log("error", error);
      setGetLoader(false);
    }
  };

  const NextStep = () => {
    if (selectedsnapshot === null) {
      setOpen(true);
    } else {
      setGetLoader(true);
      const projectID = sessionStorage.getItem("projectID");
      const body = {
        selectedsnapshot,
        projectID,
      };
      fetch(`${baseURL}/finalmodel`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((result) => {
          props.handleNextStep();
          setGetLoader(false);
        })
        .catch((error) => {
          setGetLoader(false);
          console.error("Error:", error);
        });
    }
  };
  const changeparity = () => {
    setParity(true);
    setr2q2(false);
    setLogistic(false);
    setRanking(false);
  };
  const showlogistic = () => {
    setParity(false);
    setr2q2(false);
    setLogistic(true);
    setRanking(false);
  };

  const getSpearman = () => {
    //setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(`${baseURL}/getSpearman?projectID=${ProjectID}`)
      .then((res) => res.json())
      .then((myresponse) => {
        setRanks(myresponse.allranks);
        setIndependent(myresponse.independent);
        setdependent(myresponse.dependent);
        //setGetLoader(false);
      })
      .catch((err) => {
        //setGetLoader(false);
        console.log("error", err);
      });
  };

  const showranking = () => {
    setParity(false);
    setr2q2(false);
    setLogistic(false);
    setRanking(true);
  };
  const changer2q2 = () => {
    setParity(false);
    setr2q2(true);
    setLogistic(false);
    setRanking(false);
  };

  function changeBackground(e) {
    e.target.style.background = "#ececec";
    e.target.style.textDecoration = "none";
  }

  function changeAgain(e) {
    e.target.style.background = "white";
  }
  const updatevalidationdata = (i) => {
    setValidationdata(allmodel[i]);
    setr2(allr2[i]);
    setq2(allq2[i]);
  };

  const snapshotchange = (e, i) => {
    setselectedsnapshot(i);

    updatevalidationdata(i);
    let newArr = initialState;
    newArr[i] = !newArr[i];
    setCheckedState(newArr);
    let newArray = [];
    allmodel[i].map((item, i) => {
      newArray.push(true);
    });

    setStatus(newArray);
  };
  function downloadCSV(name, y_test, y_pred, times) {
    var arr = [];

    for (var i = 0; i < y_test.length; i++) {
      arr.push([y_test[i].toFixed(3), y_pred[i].toFixed(3)]);
    }

    if (times === 1) {
      var csv = "Observed,Forecasted\n";
    } else {
      var csv = "Observed,Predicted\n";
    }

    arr.forEach(function (row) {
      csv += row.join(",");
      csv += "\n";
    });
    var hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
    hiddenElement.target = "   ";

    //provide the name for the CSV file to be downloaded
    hiddenElement.download = name + ".csv";
    hiddenElement.click();
  }
  function downloadlogisticCSV(name, y_test, y_pred) {
    var arr = [];
    for (var i = 0; i < y_test.length; i++) {
      arr.push([y_test[i], y_pred[i]]);
    }
    var csv = "Observed,Predicted\n";
    arr.forEach(function (row) {
      csv += row.join(",");
      csv += "\n";
    });
    var hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
    hiddenElement.target = "   ";

    //provide the name for the CSV file to be downloaded
    hiddenElement.download = name + ".csv";
    hiddenElement.click();
  }

  return (
    <div>
      <Dialog
        open={lineopengraph}
        onClose={handlelineClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "90%",
            maxWidth: "950px",
            borderRadius: "20px",
            border: "1px solid #0078c9",
            p: 1,
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            color: "#0078c9",
            fontSize: "16px",
            fontWeight: 600,
          }}
        >
          {lineplottitle}
        </DialogTitle>

        <Plot
          data={[
            {
              x: Array.from(Array(lineobserved.length).keys()),
              y: lineobserved,
              name: "Observed",
              mode: "lines",
              line: { color: "#17BECF" },
            },
            {
              x: Array.from(Array(lineobserved.length).keys()),
              y: linepredicted,
              name: "Predicted",
              mode: "lines",
              line: { color: "darkblue" },
            },
          ]}
          layout={{
            margin: {
              b: 55,
              l: 100,
              r: 10,
              t: 20,
            },
            width: 820,
            height: 350,
            title: {
              font: {
                size: 24,
              },
              xref: "paper",
              x: 0.05,
            },
            xaxis: {
              title: {
                text: "Count",
                font: {
                  size: 12,
                  color: "#000",
                },
              },
              linewidth: 1,
              tickangle: -90,
              //type:'date',
              //tickformat :"%Y-%m-%d-%H-%M-%S.%2f"
              //ticklen: 1,
              tickfont: {
                size: 8,
              },
              rangeslider: {
                visible: true,
                bgcolor: "lightgrey",
                thickness: 0.08,
              },
            },
            yaxis: {
              title: {
                text: "Results",
                font: {
                  size: 12,
                  color: "#000",
                },
              },
              linewidth: 1,
              ticklen: 10,
            },
          }}
          config={{
            displayModeBar: true,
            displaylogo: false,
          }}
        />
      </Dialog>
      <Dialog
        open={opengraph}
        onClose={handlegraphClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "90%",
            maxWidth: "950px",
            borderRadius: "20px",
            border: "1px solid #0078c9",
            p: 1,
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            color: "#0078c9",
            fontSize: "16px",
            fontWeight: 600,
          }}
        >
          {title}
        </DialogTitle>

        <Plot
          data={[
            {
              x: date_train,
              y: ytrain,
              name: "Real Data",
              mode: "lines",
              line: { color: "#17BECF" },
            },
            {
              x: date_train,
              y: ypred,
              name: "Predicted Data",
              mode: "lines",
              line: { color: "darkblue" },
            },
            {
              x: date_test,
              y: forecasting,
              name: "Forecasting Data",
              mode: "lines",
              line: { color: "red" },
            },
          ]}
          layout={{
            margin: {
              b: 55,
              l: 100,
              r: 10,
              t: 20,
            },
            width: 820,
            height: 350,
            title: {
              font: {
                size: 24,
              },
              xref: "paper",
              x: 0.05,
            },
            xaxis: {
              title: {
                text: "TimeStamp",
                font: {
                  size: 12,
                  color: "#000",
                },
              },
              linewidth: 1,
              tickangle: -90,
              //type:'date',
              //tickformat :"%Y-%m-%d-%H-%M-%S.%2f"
              //ticklen: 1,
              tickfont: {
                size: 8,
              },
              rangeslider: {
                visible: true,
                bgcolor: "lightgrey",
                thickness: 0.08,
              },
            },
            yaxis: {
              title: {
                text: "Forecasting",
                font: {
                  size: 12,
                  color: "#000",
                },
              },
              linewidth: 1,
              ticklen: 10,
            },
          }}
          config={{
            displayModeBar: true,
            displaylogo: false,
          }}
        />
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "18px",
            px: 2
          }
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            color: "#9e0b22",
            fontSize: "14px",
            fontWeight: 600
          }}
        >
          {"Select any one Snapshot"}
        </DialogTitle>
      </Dialog>
      {message ? (
        <div>
          <Box
            component={Paper}
            elevation={8}
            sx={{
              p: "50px",
              mt: 8,
              textAlign: "center",
              border: "1px solid #0078c9",
              borderRadius: "20px"
            }}
          >
            {" "}
            <Typography
              sx={{
                fontSize: 14,
                color: Projectcolors.primary,
                marginTop: 2,
                margin: "auto",
                padding: 20,
              }}
            >
              Please Complete Previous Steps to Validate Model
            </Typography>{" "}
          </Box>
        </div>
      ) : (
        <Box
          sx={{
            display: "flex",
            gap: 2,
            mt: 2,
            alignItems: "flex-start"
          }}
        >
          {/* LEFT DIV */}
         <Box
  component={Paper}
  elevation={5}
  sx={{
    width: 220,
    minWidth: 220,
    maxWidth: 500,

    minHeight: "75vh",
    maxHeight: "90vh",

    border: "1px solid #0078c9",
    borderRadius: "20px",

    resize: "horizontal",   // enables right-side drag
    overflow: "auto",       // required for resize to work

    flexShrink: 0,
    padding: 1,
  }}
>
            <Box
              sx={{
                bgcolor: "#0078c9",
                py: 1.5,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "white",
                  fontWeight: 600,
                }}
              >
                Plots
              </Typography>
            </Box>
            <Box sx={{ p: 1.5 }}>

              <Button
                fullWidth
                onClick={changeparity}
                sx={{
                  justifyContent: "flex-start",
                  textTransform: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#333",
                  borderRadius: "12px",
                  py: 1.2,
                  px: 2,
                  mb: 1,

                  "&:hover": {
                    bgcolor: "rgba(0,120,201,.08)",
                    color: "#0078c9",
                  },
                }}
              >
                Parity
              </Button>


              {!timeseries && (
                <Button
                  fullWidth
                  onClick={changer2q2}
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#333",
                    borderRadius: "12px",
                    py: 1.2,
                    px: 2,
                    mb: 1,

                    "&:hover": {
                      bgcolor: "rgba(0,120,201,.08)",
                      color: "#0078c9",
                    },
                  }}
                >
                  R² (Training / Testing)
                </Button>
              )}


              <Button
                fullWidth
                onClick={showranking}
                sx={{
                  justifyContent: "flex-start",
                  textTransform: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#333",
                  borderRadius: "12px",
                  py: 1.2,
                  px: 2,
                  mb: 1,

                  "&:hover": {
                    bgcolor: "rgba(0,120,201,.08)",
                    color: "#0078c9",
                  },
                }}
              >
                MB Ranking
              </Button>


              <Button
                fullWidth
                onClick={showlogistic}
                sx={{
                  justifyContent: "flex-start",
                  textTransform: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#333",
                  borderRadius: "12px",
                  py: 1.2,
                  px: 2,

                  "&:hover": {
                    bgcolor: "rgba(158,11,34,.08)",
                    color: "#9e0b22",
                  },
                }}
              >
                Logistic Regression
              </Button>

            </Box>
          </Box>

          {/* CENTER DIV */}
          <Box sx={{ flex: 1, ml: 0,width:500 }}>
           <Paper
  elevation={8}
  sx={{
    borderRadius: "20px",
    border: "1px solid #0078c9",
    p: 2,

    width: 1000,
    minWidth: 700,
    maxWidth: "100%",

    minHeight: "75vh",
    maxHeight: "90vh",

    resize: "both",      // horizontal + vertical resize
    overflow: "auto",    // required for resize

    background: "#fff",
    boxSizing: "border-box",
  }}
>
           

              {parity ? (
                cat.includes(false) ? (
                <Box
  sx={{
    height: 400,
    overflowY: "scroll",
    overflowX: "hidden",

    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      md: "repeat(2, 1fr)",
      xl: "repeat(3, 1fr)",
    },

    gap: 2,
    p: 1,

    alignContent: "start", // important
    boxSizing: "border-box",
  }}
>
                    {validationdata.map((item, i) => {
                      if (cat[i] !== false) return null;

                      return (
                      <Paper
  key={i}
  elevation={4}
  sx={{
    width: "100%",
    height: 350,

    borderRadius: "18px",
    overflow: "hidden",
    border: "1px solid #e0e0e0",

    transition: ".3s",

    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: 8,
    },
  }}
>
                          <Box
                            sx={{
                              bgcolor: "#0078c9",
                              color: "white",
                              px: 2,
                              py: 1.5,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: 14,
                                fontWeight: 600,
                              }}
                            >
                              {item[0].length > 26
                                ? item[0].substring(0, 25) + "..."
                                : item[0]}
                            </Typography>
                            <Box sx={{ display: "flex", gap: .5 }}>

                              <TableViewIcon
                                sx={{
                                  fontSize: 20,
                                  cursor: "pointer",
                                }}
                                onClick={() => handleClick(i)}
                              />

                              {timeseries ? (
                                <SsidChartOutlinedIcon
                                  sx={{
                                    fontSize: 20,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleClick(i)}
                                />
                              ) : (
                                <ScatterPlotIcon
                                  sx={{
                                    fontSize: 20,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleClick(i)}
                                />
                              )}

                              {!timeseries && (
                                <ShowChartIcon
                                  sx={{
                                    fontSize: 20,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleLinePlot(i)}
                                />
                              )}
                            </Box>
                          </Box>
                          {/* METRICS */}

                          <Box
                            sx={{
                              p: 2,
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 1,
                            }}
                          >
                            <Box
                              sx={{
                                bgcolor: "#f5f7fb",
                                px: 1.5,
                                py: .5,
                                borderRadius: "8px",
                              }}
                            >
                              <Typography sx={{ fontSize: 12 }}>
                                R² Train: {item[5]}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                bgcolor: "#f5f7fb",
                                px: 1.5,
                                py: .5,
                                borderRadius: "8px",
                              }}
                            >
                              <Typography sx={{ fontSize: 12 }}>
                                RMSE: {item[6]}
                              </Typography>
                            </Box>

                            {!timeseries && (
                              <>
                                <Box
                                  sx={{
                                    bgcolor: "#f5f7fb",
                                    px: 1.5,
                                    py: .5,
                                    borderRadius: "8px"
                                  }}
                                >
                                  <Typography sx={{ fontSize: 12 }}>
                                    R² Test: {item[7]}
                                  </Typography>
                                </Box>

                                <Box
                                  sx={{
                                    bgcolor: "#f5f7fb",
                                    px: 1.5,
                                    py: .5,
                                    borderRadius: "8px"
                                  }}
                                >
                                  <Typography sx={{ fontSize: 12 }}>
                                    RMSE: {item[8]}
                                  </Typography>
                                </Box>
                              </>
                            )}

                            {Boolean(timeseries) && (
                              <ZoomInIcon
                                sx={{
                                  ml: "auto",
                                  cursor: "pointer",
                                  color: "#0078c9",
                                  border: "1px solid #0078c9",
                                  borderRadius: "8px",
                                  p: .5
                                }}
                                onClick={() =>
                                  handlegraphOpen(
                                    item[0],
                                    item[3],
                                    item[4]
                                  )
                                }
                              />
                            )}
                          </Box>




                          <Box
                            sx={{
                              p: 1,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              minHeight: 220
                            }}
                          >



                            {status[i] ? (
                              typeof item[1] === "string" ? (
                                <div>
                                  {timeseries ? (
                                    <Plot
                                      data={[
                                        {
                                          x: item[3][0],
                                          y: item[4][0],
                                          name: "Real Data",
                                          mode: "lines",
                                          line: { color: "#17BECF" },
                                        },
                                        {
                                          x: item[3][0],
                                          y: item[4][1],
                                          name: "Predicted Data",
                                          mode: "lines",
                                          line: { color: "#7F7F7F" },
                                        },
                                        {
                                          x: item[3][1],
                                          y: item[4][2],
                                          name: "Forecasting Data",
                                          mode: "lines",
                                          line: { color: "red" },
                                        },
                                      ]}
                                      layout={{
                                        margin: {
                                          b: 65,
                                          l: 55,
                                          r: 10,
                                          t: 20,
                                        },
                                        width: 300,
                                        height: 180,
                                        title: {
                                          font: {
                                            size: 24,
                                          },
                                          xref: "paper",
                                          x: 0.05,
                                        },
                                        xaxis: {
                                          title: {
                                            text: "TimeStamp",
                                            font: {
                                              size: 12,
                                              color: "#000",
                                            },
                                          },
                                          linewidth: 1,
                                          tickangle: 45,
                                          //type:'date',
                                          //tickformat :"%Y-%m-%d-%H-%M-%S.%2f"
                                          //ticklen: 1,
                                          tickfont: {
                                            size: 4,
                                          },
                                        },
                                        yaxis: {
                                          title: {
                                            text: "Forecasting",
                                            font: {
                                              size: 12,
                                              color: "#000",
                                            },
                                          },
                                          linewidth: 1,
                                          ticklen: 10,
                                        },
                                        showlegend: false,
                                      }}
                                      config={{
                                        displayModeBar: false,
                                        displaylogo: false,
                                      }}
                                    />
                                  ) : (
                                    <Plot
                                      data={[
                                        {
                                          x: item[3],
                                          y: item[3],
                                          type: "scatter",
                                          mode: "lines",
                                          marker: { color: "#81888f" },
                                        },
                                        {
                                          x: item[3],
                                          y: item[4],
                                          type: "scatter",
                                          mode: "markers",
                                          marker: {
                                            color: Projectcolors.primary,
                                          },
                                        },
                                      ]}
                                      layout={{
                                        margin: {
                                          b: 68,
                                          l: 73,
                                          r: 10,
                                          t: 20,
                                        },
                                        width: 300,
                                        height: 170,
                                        title: {
                                          font: {
                                            size: 24,
                                          },
                                          xref: "paper",
                                          x: 0.05,
                                        },
                                        xaxis: {
                                          title: {
                                            text: "Observed",
                                            font: {
                                              size: 12,
                                              color: "#000",
                                            },
                                          },
                                          linewidth: 1,
                                          ticklen: 10,
                                        },
                                        yaxis: {
                                          title: {
                                            text: "Predicted",
                                            font: {
                                              size: 12,
                                              color: "#000",
                                            },
                                          },
                                          linewidth: 1,
                                          ticklen: 10,
                                        },
                                      }}
                                      config={{
                                        displayModeBar: false,
                                        displaylogo: false,
                                      }}
                                    />
                                  )}
                                </div>
                              ) : (
                                <div>
                                  <Plot
                                    data={[
                                      {
                                        x: item[1].length,
                                        y: item[1][0],
                                        name: "Training Loss",
                                        type: "scatter",
                                        mode: "lines",
                                        marker: { color: "green" },
                                      },
                                      {
                                        x: item[1].length,
                                        y: item[1][1],
                                        name: "Validation Loss",
                                        type: "scatter",
                                        mode: "lines",
                                        marker: {
                                          color: Projectcolors.primary,
                                        },
                                      },
                                    ]}
                                    layout={{
                                      margin: { b: 65, l: 70, r: 0, t: 20 },
                                      width: 300,
                                      height: 170,
                                      title: {
                                        font: {
                                          size: 10,
                                        },
                                        xref: "paper",
                                        x: 0.05,
                                      },
                                      xaxis: {
                                        title: {
                                          text: "Epochs",
                                          font: {
                                            size: 11,
                                            color: "#000",
                                          },
                                        },
                                        linewidth: 1,
                                        ticklen: 10,
                                      },
                                      yaxis: {
                                        title: {
                                          text: "Loss",
                                          font: {
                                            size: 11,
                                            color: "#000",
                                          },
                                        },
                                        linewidth: 1,
                                        ticklen: 10,
                                      },
                                    }}
                                    config={{
                                      displayModeBar: false,
                                      displaylogo: false,
                                    }}
                                  />
                                </div>
                              )
                            ) : (
                              <div>
                                {timeseries ? (
                                  <TableContainer
                                    component={Paper}
                                    elevation={2}
                                    sx={{
                                      width: 210,
                                      height: 175,
                                      padding: 0,
                                      display: "block",
                                      marginLeft: "auto",
                                      marginRight: "auto",
                                      marginTop: 2,
                                    }}
                                  >
                                    <Table
                                      aria-label="sticky table"
                                      stickyHeader
                                      sx={{ color: "black" }}
                                    >
                                      <TableHead
                                        sx={{
                                          backgroundColor:
                                            Projectcolors.primary,
                                          height: 10,
                                        }}
                                      >
                                        <StyledTableRow>
                                          <StyledTableCell
                                            sx={{
                                              // padding: "7px",
                                              fontSize: 11,
                                              color: "white",
                                              fontWeight: "bold",
                                              backgroundColor:
                                                Projectcolors.primary,
                                            }}
                                          >
                                            Observed
                                          </StyledTableCell>
                                          <StyledTableCell
                                            sx={{
                                              // padding: "7px",
                                              fontSize: 11,
                                              color: "white",
                                              fontWeight: "bold",
                                              backgroundColor:
                                                Projectcolors.primary,
                                            }}
                                          >
                                            Predicted{" "}
                                          </StyledTableCell>

                                          <StyledTableCell
                                            sx={{
                                              // padding: "7px",
                                              width: 10,
                                              color: "white",
                                              fontWeight: "bold",
                                              backgroundColor:
                                                Projectcolors.primary,
                                            }}
                                          >
                                            <DownloadIcon
                                              sx={{
                                                fontSize: "small",
                                                marginTop: 1,
                                                marginRight: 2,
                                              }}
                                              onClick={() =>
                                                downloadCSV(
                                                  item[0],
                                                  item[4][3],
                                                  item[4][2],
                                                  1
                                                )
                                              }
                                            />
                                          </StyledTableCell>
                                        </StyledTableRow>
                                      </TableHead>

                                      <TableBody>
                                        {item[4][2].map((x, i) => {
                                          return (
                                            <StyledTableRow>
                                              <StyledTableCell
                                                sx={{ fontSize: 11 }}
                                              >
                                                {item[4][3][i]
                                                  .toString()
                                                  .startsWith("0.") ||
                                                  item[4][3][i]
                                                    .toString()
                                                    .startsWith("-0.")
                                                  ? item[4][3][
                                                    i
                                                  ].toExponential(3)
                                                  : item[4][3][i].toFixed(
                                                    3
                                                  )}
                                              </StyledTableCell>

                                              <StyledTableCell
                                                sx={{ fontSize: 11 }}
                                              >
                                                {x
                                                  .toString()
                                                  .startsWith("0.") ||
                                                  x
                                                    .toString()
                                                    .startsWith("-0.")
                                                  ? x.toExponential(3)
                                                  : x.toFixed(3)}
                                              </StyledTableCell>
                                              <StyledTableCell
                                                sx={{ fontSize: 11 }}
                                              ></StyledTableCell>
                                            </StyledTableRow>
                                          );
                                        })}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                ) : (
                                  <div>
                                    {linestatus[i] ? (
                                      <div>
                                        <ZoomInIcon
                                          sx={{
                                            display: "inline",
                                            float: "right",
                                            fontSize: 20,
                                            marginRight: 1,
                                            color: "black",
                                            border: 1,
                                          }}
                                          onClick={() =>
                                            handlelineOpen(item[3], item[4], item[0])

                                          }
                                        />
                                        <Plot
                                          data={[
                                            {
                                              x: Array.from(Array(item[3].length).keys()),
                                              y: item[3],
                                              name: "Observed",
                                              mode: "lines",
                                              line: { color: "#17BECF" },
                                            },
                                            {
                                              x: Array.from(Array(item[3].length).keys()),
                                              y: item[4],
                                              name: "Predicted",
                                              mode: "lines",
                                              line: { color: "darkblue" },
                                            },

                                          ]}
                                          layout={{
                                            margin: {
                                              b: 75,
                                              l: 75,
                                              r: 20,
                                              t: 20,
                                            },
                                            width: 300,
                                            height: 150,
                                            title: {
                                              font: {
                                                size: 24,
                                              },
                                              xref: "paper",
                                              x: 0.05,
                                            },
                                            xaxis: {
                                              title: {
                                                text: "Count",
                                                font: {
                                                  size: 12,
                                                  color: "#000",
                                                },
                                              },
                                              linewidth: 1,
                                              tickangle: 45,
                                              //type:'date',
                                              //tickformat :"%Y-%m-%d-%H-%M-%S.%2f"
                                              //ticklen: 1,
                                              tickfont: {
                                                size: 4,
                                              },
                                            },
                                            yaxis: {
                                              title: {
                                                text: "Results",
                                                font: {
                                                  size: 12,
                                                  color: "#000",
                                                },
                                              },
                                              linewidth: 1,
                                              ticklen: 10,
                                            },
                                            showlegend: false,
                                          }}
                                          config={{
                                            displayModeBar: false,
                                            displaylogo: false,
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <div>
                                        <TableContainer
                                          component={Paper}
                                          elevation={2}
                                          sx={{
                                            width: 210,
                                            height: 150,
                                            padding: 0,
                                            display: "block",
                                            marginLeft: "auto",
                                            marginRight: "auto",
                                            marginTop: 2,
                                            //border: 1,
                                            //borderWidth: "2px",
                                            //borderColor: "black",
                                          }}
                                        >
                                          <Table
                                            aria-label="sticky table"
                                            stickyHeader
                                            sx={{ color: "black" }}
                                          >
                                            <TableHead
                                              sx={{
                                                backgroundColor:
                                                  Projectcolors.primary,
                                                height: 10,
                                              }}
                                            >
                                              <StyledTableRow>
                                                <StyledTableCell
                                                  sx={{
                                                    // padding: "7px",
                                                    fontSize: 11,
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    backgroundColor:
                                                      Projectcolors.primary,
                                                  }}
                                                >
                                                  Observed
                                                </StyledTableCell>
                                                <StyledTableCell
                                                  sx={{
                                                    // padding: "7px",
                                                    fontSize: 11,
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    backgroundColor:
                                                      Projectcolors.primary,
                                                  }}
                                                >
                                                  Predicted{" "}
                                                </StyledTableCell>

                                                <StyledTableCell
                                                  sx={{
                                                    // padding: "7px",
                                                    width: 10,
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    backgroundColor:
                                                      Projectcolors.primary,
                                                  }}
                                                >
                                                  <DownloadIcon
                                                    sx={{
                                                      fontSize: "small",
                                                      marginTop: 1,
                                                      marginRight: 2,
                                                    }}
                                                    onClick={() =>
                                                      downloadCSV(
                                                        item[0],
                                                        item[3],
                                                        item[4],
                                                        0
                                                      )
                                                    }
                                                  />
                                                </StyledTableCell>
                                              </StyledTableRow>
                                            </TableHead>

                                            <TableBody>
                                              {item[3].map((x, i) => {
                                                return (
                                                  <StyledTableRow>
                                                    <StyledTableCell
                                                      sx={{ fontSize: 11 }}
                                                    >
                                                      {x
                                                        .toString()
                                                        .startsWith("0.") ||
                                                        x
                                                          .toString()
                                                          .startsWith("-0.")
                                                        ? x.toExponential(3)
                                                        : x.toFixed(3)}
                                                    </StyledTableCell>

                                                    <StyledTableCell
                                                      sx={{ fontSize: 11 }}
                                                    >
                                                      {item[4][i]
                                                        .toString()
                                                        .startsWith("0.") ||
                                                        item[4][i]
                                                          .toString()
                                                          .startsWith("-0.")
                                                        ? item[4][
                                                          i
                                                        ].toExponential(3)
                                                        : item[4][i].toFixed(3)}
                                                    </StyledTableCell>
                                                    <StyledTableCell
                                                      sx={{ fontSize: 11 }}
                                                    ></StyledTableCell>
                                                  </StyledTableRow>
                                                );
                                              })}
                                            </TableBody>
                                          </Table>
                                        </TableContainer>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </Box>
                        </Paper>
                      );
                    })}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60vh"
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 16,
                        color: "#0078c9",
                        fontWeight: 600
                      }}
                    >
                      Categorical Data Trained on Logistic Regression
                    </Typography>
                  </Box>

                ) 
              )
                : null}

                             {/* MB RANKING */}
{ranking && cat.includes(false) ? (
  <Paper
    elevation={8}
    sx={{
      borderRadius: "20px",
      border: "1px solid #0078c9",
      overflow: "hidden",
      mt: 1,
    }}
  >
    {/* HEADER */}

    <Box
      sx={{
        bgcolor: "#0078c9",
        color: "white",
        px: 3,
        py: 1.5,
      }}
    >
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
        }}
      >
        MB Ranking
      </Typography>
    </Box>

    {/* BODY */}

    <Box
      sx={{
        display: "flex",
        flexDirection: {
          xs: "column",
          md: "row",
        },
        p: 2,
        gap: 2,
      }}
    >
      {/* LEFT PANEL */}

      <Paper
        elevation={0}
        sx={{
          width: {
            xs: "100%",
            md: 240,
          },
          border: "1px solid #e5e5e5",
          borderRadius: "14px",
          p: 1,
          maxHeight: 420,
          overflowY: "auto",
        }}
      >
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 600,
            color: "#0078c9",
            mb: 1,
            px: 1,
          }}
        >
          Dependent Variables
        </Typography>

        {dependent ? (
          dependent.map((item, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                alignItems: "center",
                px: 1,
                py: .7,
                borderRadius: "10px",
                cursor: "pointer",

                backgroundColor:
                  selectedValue === i
                    ? "rgba(0,120,201,.08)"
                    : "transparent",

                "&:hover": {
                  backgroundColor:
                    "rgba(0,120,201,.05)",
                },
              }}
              onClick={() =>
                handleChange(item, i)
              }
            >
              <Radio
                checked={
                  selectedValue === i
                }
                size="small"
                sx={{
                  color: "#0078c9",

                  "&.Mui-checked": {
                    color: "#9e0b22",
                  },
                }}
              />

              <Typography
                sx={{
                  fontSize: 12,
                  ml: .5,
                }}
              >
                {item}
              </Typography>
            </Box>
          ))
        ) : (
          <Typography
            sx={{
              fontSize: 12,
              p: 2,
            }}
          >
            No variables available
          </Typography>
        )}
      </Paper>

      {/* CHART */}

      <Paper
        elevation={0}
        sx={{
          flex: 1,
          border: "1px solid #e5e5e5",
          borderRadius: "14px",
          p: 2,
          overflowX: "auto",
        }}
      >
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 600,
            color: "#0078c9",
            mb: 2,
          }}
        >
          Ranking Plot
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Plot
            data={[
              {
                x: independent,
                y: ranks[selectedValue],
                type: "bar",
                width: .35,
              },
            ]}
            layout={{
              width: 650,
              height: 380,

              margin: {
                l: 50,
                r: 20,
                t: 20,
                b: 90,
              },

              xaxis: {
                automargin: true,
                tickangle: -25,
              },

              yaxis: {
                automargin: true,
              },

              paper_bgcolor: "white",
              plot_bgcolor: "white",
            }}
            config={{
              displaylogo: false,
              responsive: true,
            }}
          />
        </Box>
      </Paper>
    </Box>
  </Paper>
) : null}


            {r2q2 ? (
  cat.includes(false) ? (
    <Paper
      elevation={8}
      sx={{
        borderRadius: "20px",
        border: "1px solid #0078c9",
        overflow: "hidden",
        mt: 1,
      }}
    >
      {/* HEADER */}

      <Box
        sx={{
          bgcolor: "#0078c9",
          color: "white",
          px: 3,
          py: 1.5,
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 600,
          }}
        >
          R² (Training) / R² (Testing)
        </Typography>
      </Box>

      {/* BODY */}

      <Box sx={{ p: 3 }}>

        {/* METRIC CHIPS */}

        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            mb: 2,
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 1,
              bgcolor: "rgba(0,120,201,.08)",
              borderRadius: "10px",
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                color: "#0078c9",
                fontWeight: 600,
              }}
            >
              Blue → R² Training
            </Typography>
          </Box>

          <Box
            sx={{
              px: 2,
              py: 1,
              bgcolor: "rgba(158,11,34,.08)",
              borderRadius: "10px",
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                color: "#9e0b22",
                fontWeight: 600,
              }}
            >
              Red → R² Testing
            </Typography>
          </Box>
        </Box>

        {/* PLOT */}

        <Box
          sx={{
            width: "100%",
            overflowX: "auto",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Plot
            data={[
              {
                x: labels,
                y: r2,
                name: "R² Training",
                type: "bar",
              },

              {
                x: labels,
                y: q2,
                name: "R² Testing",

                type: "bar",

                marker: {
                  color: "#9e0b22",
                },
              },
            ]}
            layout={{
              barmode: "group",

              width: 900,
              height: 420,

              margin: {
                l: 60,
                r: 20,
                t: 20,
                b: 100,
              },

              paper_bgcolor: "white",
              plot_bgcolor: "white",

              xaxis: {
                title: {
                  text: "Variables",
                  font: {
                    size: 12,
                  },
                },

                tickangle: -25,
                automargin: true,
              },

              yaxis: {
                title: {
                  text:
                    "R² Score",
                  font: {
                    size: 12,
                  },
                },
              },
            }}
            config={{
              responsive: true,
              displaylogo: false,
            }}
          />
        </Box>
      </Box>
    </Paper>
  ) : (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
      }}
    >
      <Typography
        sx={{
          fontSize: 16,
          color: "#0078c9",
          fontWeight: 600,
        }}
      >
        Categorical Data Trained on Logistic Regression
      </Typography>
    </Box>
  )
) : null}

       {logistic && (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: 2,
      p: 2,
      width: "100%",
    }}
  >
    {cat.includes(true) ? (
      validationdata.map((item, i) => {
        if (cat[i] !== true) return null;

        return (
          <Paper
            key={i}
            elevation={4}
            sx={{
              width: 330,
              borderRadius: "20px",
              overflow: "hidden",
              border: "1px solid #e8eef5",
              boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                background: "#0078c9",
                color: "white",
                px: 2,
                py: 1.5,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                {item[0].length > 24
                  ? item[0].substring(0, 24) + "..."
                  : item[0]}
              </Typography>

              <Box sx={{ display: "flex", gap: 1 }}>
                <ScatterPlotIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleClick(i)}
                />

                <TableViewIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleClick(i)}
                />
              </Box>
            </Box>

            {/* Metrics */}
            <Box
              sx={{
                px: 2,
                py: 2,
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 1,
              }}
            >
              {[
                ["Precision", item[6][0]],
                ["Recall", item[6][1]],
                ["F1 Score", item[7]],
                ["Accuracy", item[8]],
              ].map(([label, value]) => (
                <Paper
                  key={label}
                  elevation={0}
                  sx={{
                    p: 1,
                    borderRadius: "14px",
                    bgcolor: "#f7fafc",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#666",
                    }}
                  >
                    {label}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#9e0b22",
                    }}
                  >
                    {value}
                  </Typography>
                </Paper>
              ))}
            </Box>

            {/* Plot/Table area */}
            <Box sx={{ px: 2, pb: 2 }}>

              {status[i] ? (
                <Plot
                  data={[
                    {
                      x: item[5][0],
                      y: item[5][1],
                      mode: "lines",
                      marker: {
                        color: "#0078c9",
                      },
                    },
                  ]}
                  layout={{
                    width: 285,
                    height: 180,
                    margin: {
                      l: 50,
                      r: 10,
                      t: 10,
                      b: 45,
                    },

                    xaxis: {
                      title: "FPR",
                    },

                    yaxis: {
                      title: "TPR",
                    },

                    showlegend: false,
                  }}
                  config={{
                    displayModeBar: false,
                    displaylogo: false,
                  }}
                />
              ) : (
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    borderRadius: "16px",
                    border: "1px solid #eee",
                    maxHeight: 180,
                  }}
                >
                  <Table stickyHeader>

                    <TableHead>
                      <TableRow>

                        <TableCell
                          sx={{
                            bgcolor: "#0078c9",
                            color: "white",
                            fontSize: 12,
                          }}
                        >
                          Observed
                        </TableCell>

                        <TableCell
                          sx={{
                            bgcolor: "#0078c9",
                            color: "white",
                            fontSize: 12,
                          }}
                        >
                          Predicted
                        </TableCell>

                        <TableCell
                          sx={{
                            bgcolor: "#0078c9",
                            color: "white",
                            width: 40,
                          }}
                        >
                          <DownloadIcon
                            sx={{
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              downloadlogisticCSV(
                                item[0],
                                item[3],
                                item[4]
                              )
                            }
                          />
                        </TableCell>

                      </TableRow>
                    </TableHead>

                    <TableBody>

                      {item[3].map((x, idx) => (
                        <TableRow key={idx}>
                          <TableCell sx={{ fontSize: 12 }}>
                            {x}
                          </TableCell>

                          <TableCell sx={{ fontSize: 12 }}>
                            {item[4][idx]}
                          </TableCell>

                          <TableCell />
                        </TableRow>
                      ))}

                    </TableBody>
                  </Table>
                </TableContainer>
              )}

            </Box>
          </Paper>
        );
      })
    ) : (
      <Typography
        sx={{
          m: "auto",
          fontSize: 14,
          color: "#0078c9",
          fontWeight: 600,
        }}
      >
        No Categorical Data Trained on Logistic Regression
      </Typography>
    )}
  </Box>
)}

{logistic ? (
  <Paper
    elevation={4}
    sx={{
      mt: 2,
      borderRadius: "20px",
      overflow: "hidden",
      border: "1px solid #e8eef5",
      boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
    }}
  >
    <Box
      sx={{
        px: 3,
        py: 2,
        bgcolor: "#f8fbff",
        borderBottom: "1px solid #e8eef5",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#0078c9",
        }}
      >
        Logistic Regression Summary
      </Typography>
    </Box>

    <TableContainer sx={{ maxHeight: 280 }}>
      <Table stickyHeader>

        <TableHead>
          <TableRow>

            {[
              "Variables",
              "Precision",
              "Recall",
              "F1 Score",
              "Accuracy",
            ].map((head) => (
              <TableCell
                key={head}
                sx={{
                  backgroundColor: "#0078c9",
                  color: "white",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                {head}
              </TableCell>
            ))}

          </TableRow>
        </TableHead>

        <TableBody>
          {validationdata.map((x, i) =>
            cat[i] === true ? (
              <TableRow
                key={i}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    background: "#fafcff",
                  },
                }}
              >
                <TableCell sx={{ fontSize: 12 }}>
                  {x[0]}
                </TableCell>

                <TableCell sx={{ fontSize: 12 }}>
                  {x[6][0]}
                </TableCell>

                <TableCell sx={{ fontSize: 12 }}>
                  {x[6][1]}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize: 12,
                    color: "#9e0b22",
                    fontWeight: 600,
                  }}
                >
                  {x[7]}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize: 12,
                    fontWeight: 600,
                  }}
                >
                  {x[8]}
                </TableCell>
              </TableRow>
            ) : null
          )}
        </TableBody>

      </Table>
    </TableContainer>
  </Paper>
) : (
  <Paper
    elevation={4}
    sx={{
      mt: 2,
      borderRadius: "20px",
      overflow: "hidden",
      border: "1px solid #e8eef5",
      boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
    }}
  >
    <Box
      sx={{
        px: 3,
        py: 2,
        bgcolor: "#f8fbff",
        borderBottom: "1px solid #e8eef5",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#0078c9",
        }}
      >
        Model Validation Summary
      </Typography>
    </Box>

    <TableContainer sx={{ maxHeight: 280 }}>
      <Table stickyHeader>

        <TableHead>
          <TableRow>

            <TableCell sx={headerStyle}>
              Variables
            </TableCell>

            <TableCell sx={headerStyle}>
              Accuracy (R² Training)
            </TableCell>

            <TableCell sx={headerStyle}>
              RMSE Training
            </TableCell>

            {!timeseries && (
              <TableCell sx={headerStyle}>
                Predictability (R² Testing)
              </TableCell>
            )}

            {!timeseries && (
              <TableCell sx={headerStyle}>
                RMSE Testing
              </TableCell>
            )}

          </TableRow>
        </TableHead>

        <TableBody>

          {validationdata.map((x, i) =>
            cat[i] === false ? (
              <TableRow
                key={i}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    background: "#fafcff",
                  },
                }}
              >
                <TableCell sx={{ fontSize: 12 }}>
                  {x[0]}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#9e0b22",
                  }}
                >
                  {x[5]}
                </TableCell>

                <TableCell sx={{ fontSize: 12 }}>
                  {x[6]}
                </TableCell>

                {!timeseries && (
                  <TableCell sx={{ fontSize: 12 }}>
                    {x[7]}
                  </TableCell>
                )}

                {!timeseries && (
                  <TableCell sx={{ fontSize: 12 }}>
                    {x[8]}
                  </TableCell>
                )}
              </TableRow>
            ) : null
          )}

        </TableBody>

      </Table>
    </TableContainer>
  </Paper>
)}


      </Paper>
    </Box>

   {/* RIGHT PANEL */}

<Paper
  elevation={4}
  sx={{
    mt: 1,
    width: 350,
    minHeight: "75vh",
    maxHeight: "90vh",
    borderRadius: "24px",
    overflow: "hidden",
    border: "1px solid #0078c9",
    boxShadow: "0 4px 20px rgba(0,0,0,.08)",
  }}
>
  {/* Header */}

  <Box
    sx={{
      bgcolor: "#0078c9",
      px: 2,
      py: 1.5,
    }}
  >
    <Typography
      sx={{
        color: "white",
        fontSize: 16,
        fontWeight: 600,
      }}
    >
      Snapshot KPI
    </Typography>
  </Box>

  {/* Body */}

  <Box
    sx={{
      p: 2,
      maxHeight: "540px",
      overflowY: "auto",
    }}
  >
    {allmodel.map((eachmodel, j) => (
      <Paper
        key={j}
        elevation={2}
        sx={{
          p: 2,
          mb: 2,
          borderRadius: "20px",
          border: checkedState[j]
            ? "2px solid #9e0b22"
            : "1px solid #e8eef5",

          transition: ".3s",
        }}
      >
        {/* snapshot header */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Radio
              key={j}
              checked={checkedState[j]}
              onChange={(e) =>
                snapshotchange(e, j)
              }
              sx={{
                color: "#0078c9",

                "&.Mui-checked": {
                  color: "#9e0b22",
                },
              }}
            />

            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              Snapshot {j}
            </Typography>
          </Box>

          <DeleteIcon
            onClick={() =>
              deleteSnap(j)
            }
            sx={{
              color: "#9e0b22",
              cursor: "pointer",
              fontSize: 20,
            }}
          />
        </Box>

        {/* mini metrics */}

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns:
              "1fr 1fr",
            gap: 1,
            mb: 2,
          }}
        >
          <Paper
            elevation={0}
            sx={{
              p: 1,
              bgcolor: "#f7fafc",
              borderRadius: "14px",
            }}
          >
            <Typography
              sx={{
                fontSize: 11,
                color: "#777",
              }}
            >
              Variables
            </Typography>

            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              {eachmodel.length}
            </Typography>
          </Paper>

          {typeof eachmodel[0][1] !==
            "string" && (
            <Paper
              elevation={0}
              sx={{
                p: 1,
                bgcolor: "#f7fafc",
                borderRadius: "14px",
              }}
            >
              <Typography
                sx={{
                  fontSize: 11,
                  color: "#777",
                }}
              >
                Epochs
              </Typography>

              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#9e0b22",
                }}
              >
                {eachmodel[0][9][2]}
              </Typography>
            </Paper>
          )}
        </Box>

        {/* Details */}

        {eachmodel.map((item, i) => (
          <Box
            key={i}
            sx={{
              mb: 2,
              p: 1.5,
              borderRadius: "14px",
              bgcolor: "#fafcff",
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 600,
                color: "#0078c9",
                mb: .5,
              }}
            >
              {item[0]}
            </Typography>

            <Typography
              sx={{
                fontSize: 12,
              }}
            >
              Method:
              {" "}
              {typeof item[1] ===
              "string"
                ? item[1]
                : "ANN"}
            </Typography>

            {cat[i] === false ? (
              <>
                <Typography sx={{fontSize:12}}>
                  R² Train: {item[5]}
                </Typography>

                <Typography sx={{fontSize:12}}>
                  RMSE: {item[6]}
                </Typography>

                {!timeseries && (
                  <>
                    <Typography sx={{fontSize:12}}>
                      R² Test:
                      {" "}
                      {item[7]}
                    </Typography>

                    <Typography sx={{fontSize:12}}>
                      RMSE Test:
                      {" "}
                      {item[8]}
                    </Typography>
                  </>
                )}
              </>
            ) : (
              <>
                <Typography sx={{fontSize:12}}>
                  Precision:
                  {" "}
                  {item[6][0]}
                </Typography>

                <Typography sx={{fontSize:12}}>
                  Recall:
                  {" "}
                  {item[6][1]}
                </Typography>

                <Typography sx={{fontSize:12}}>
                  F1:
                  {" "}
                  {item[7]}
                </Typography>

                <Typography sx={{fontSize:12}}>
                  Accuracy:
                  {" "}
                  {item[8]}
                </Typography>
              </>
            )}
          </Box>
        ))}
      </Paper>
    ))}
  </Box>

  {/* footer */}

  <Box
    sx={{
      p: 2,
      borderTop:
        "1px solid #eee",
    }}
  >
    <Button
      onClick={NextStep}
      disabled={!props.editAccess}
      variant="contained"
      fullWidth
      sx={{
        borderRadius: "14px",
        bgcolor: "#0078c9",
        height: 45,
        textTransform: "none",
        fontSize: 14,

        "&:hover": {
          bgcolor: "#006cb5",
        },
      }}
      endIcon={
        <ChevronRightIcon />
      }
    >
      Continue
    </Button>
  </Box>
</Paper>   
        </Box >
      )
}

{ getLoader ? <GlobalLoader /> : null }
    </div >
  );
}

export default Validate;
